<template>
  <table class="b-table table table-bordered bg-white b-table-stacked-md">
    <tbody>
      <tr>
        <td>
          <strong v-if="item.nome_social">
            {{ item.nome_social }} <br />
            ( N.R.: )
            <a v-if="!nome" href="#" @click.prevent="nome = true"
              ><i class="fas fa-eye"></i
            ></a>
            <span v-if="nome">
              {{ item.nome_completo }}
              <a href="#" @click.prevent="nome = false"
                ><i class="fas fa-eye-slash"></i
              ></a>
            </span>
          </strong>
          <strong v-else>
            {{ item.nome_completo }}
          </strong>
          <b-link
            :to="'/dashboard/familias/edit/' + item.familia_id"
            :title="$t('Ver Prontuário Familiar')"
            v-b-tooltip.hover
          >
            <i class="fas fa-external-link-alt"></i>
          </b-link>
          <br />

          <small class="text-muted">
            Idade: {{ item.idade_extenso }} <br />
            Posição Familiar:
            {{ item.posicao_familiar_nome }}
          </small>
        </td>

        <td>
          <span v-if="item.codigo_usuario_cadunico != null">
            Código Cadúnico:
            <strong>{{ item.codigo_usuario_cadunico }}</strong>
          </span>
          <span v-else>
            ID no Sistema:
            <strong>{{ item.id }}</strong>
          </span>
        </td>
        <td>
          <span v-if="item.codigo_usuario_cadunico != null">
            Usuário Importado
            <strong>{{ item.cadastro }}</strong>
          </span>
          <span v-else>
            Usuário Cadastrado
            <strong>{{ item.cadastro }}</strong>
          </span>
        </td>
        <td>
          <span>
            Estado Cadastral:
            <span class="small" v-html="item.estado_cadastral"></span>
            <span v-if="item.estado_cadastral_cadunico == 4">
              <i
                class="mdi mdi-information mdi-18px text-danger"
                title="Visualizar motivo exclusão"
                style="cursor: pointer"
                @click="$emit('show-exclusao')"
              ></i>
            </span>
            <br />
            <span v-if="item.usuario_origem_id">
              <a
                class="btn btn-default btn-xs"
                :href="'/dashboard/usuario/edit/' + item.usuario_origem_id"
                target="_blank"
              >
                <b>Prontuário Antigo</b>
                <i class="fas fa-external-link-alt"></i>
              </a>
            </span>
            <span v-if="item.usuario_destino_id">
              <a
                class="btn btn-default btn-xs"
                :href="'/dashboard/usuario/edit/' + item.usuario_destino_id"
                target="_blank"
              >
                <b>Prontuário Novo</b>
                <i class="fas fa-external-link-alt"></i>
              </a>
            </span>
          </span>
        </td>
      </tr>
      <tr v-if="!show">
        <td colspan="4" class="text-center">
          <a
            href="#"
            class="font-weight-light font-italic"
            @click.prevent="show = true"
          >
            <i class="fas fa-plus"></i> Mais detalhes
          </a>
        </td>
      </tr>
      <tr v-if="show">
        <td>
          Contato:
          <span v-if="item.codigo_familiar != null && item.contatos">
            <strong>{{ item.contatos.telefone_um }}</strong>
          </span>
          <span v-else>
            <strong>{{ item.celular }}</strong>
          </span>
        </td>
        <td>
          <span>
            Data de Nascimento:
            <strong>{{ item.data_nascimento }}</strong>
          </span>
        </td>
        <td>
          CPF:
          <strong>{{ item.documento ? item.documento.cpf : "" }}</strong>

          <b-link
            href="#"
            v-if="item.documento && item.documento.cpf == null"
            v-b-tooltip.hover
            title="Não sabe o número do CPF ou não foi inserido no cadastro!"
          >
            <b-icon
              icon="exclamation-triangle-fill"
              variant="warning"
              animation="fade"
            ></b-icon>
          </b-link>
        </td>
        <td>
          NIS:
          <strong>{{ item.documento ? item.documento.nis : "" }}</strong>

          <b-link
            href="#"
            v-if="item.documento && item.documento.nis == null"
            v-b-tooltip.hover
            title="Não sabe o número do NIS ou não foi inserido no cadastro!"
          >
            <b-icon
              icon="exclamation-triangle-fill"
              variant="warning"
              animation="fade"
            ></b-icon>
          </b-link>
        </td>
      </tr>
      <tr v-if="show">
        <td colspan="2">
          <span v-if="item.codigo_usuario_cadunico != null">
            Data da última atualização no CadÚnico:
            <strong>{{ item.atualizacao_cadunico }}</strong>
          </span>
          <span v-else>
            Data da última atualização no sistema:
            <strong>{{ item.atualizacao }}</strong>
          </span>
        </td>
        <td colspan="2">
          <span v-if="item.codigo_usuario_cadunico != null">
            Técnico que importou:
            <strong>{{ item.user.name }} - {{ item.unidade.nome }}</strong>
          </span>
          <span v-else>
            Técnico que realizou o cadastro:
            <strong>{{ item.user.name }} - {{ item.unidade.nome }}</strong>
          </span>
        </td>
      </tr>
      <tr v-if="show">
        <td colspan="4" class="text-center">
          <a
            href="#"
            class="font-weight-light font-italic"
            @click.prevent="show = false"
          >
            <i class="fas fa-times"></i> Fechar mais detalhes
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      show: false,
      nome: false,
    };
  },
  watch: {
    show: function (value) {
      value ? true : false;
    },
    nome: function (value) {
      value ? true : false;
    },
  },
};
</script>
